import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { toolsDetailsToolConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsToolStack = createStackNavigator();

const ToolsDetailsToolNavigator = () => {
  return (
    <ToolsDetailsToolStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {toolsDetailsToolConfig.map(({ Component, name }) => (
        <ToolsDetailsToolStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolsDetailsToolStack.Navigator>
  );
};

export { ToolsDetailsToolNavigator };
